import { render, staticRenderFns } from "./alertSubscribe.vue?vue&type=template&id=6c023e77&scoped=true&"
import script from "./alertSubscribe.vue?vue&type=script&lang=js&"
export * from "./alertSubscribe.vue?vue&type=script&lang=js&"
import style0 from "./alertSubscribe.vue?vue&type=style&index=0&id=6c023e77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c023e77",
  null
  
)

export default component.exports